import { analyticsTrackEvent } from "./common";

/* @TODO unify all analytics calls to use either analyticsTrackEvent directly, 
 or replace analyticsTrackEvent with previous version of trackBasicEvent (dataLayer.push); */
export const trackBasicEvent = (category, action, label) => {
  analyticsTrackEvent(`${category} - ${label}`);
};
